import { useParamAsInteger } from '@cibo/ui'
import { useCallback } from 'react'
import { generatePath, useNavigate } from 'react-router-dom'
import { DrawField } from './DrawField'

export const UserDrawField = ({
  completeRoute,
  profilingRoute,
  enrollRoute,
}: {
  completeRoute: string
  profilingRoute: string
  enrollRoute: string
}) => {
  const navigate = useNavigate()
  const userId = useParamAsInteger('userId')

  const handleCancel = useCallback(() => {
    navigate(generatePath(completeRoute, { userId: userId?.toString() }))
  }, [])
  const handleComplete = useCallback(() => {
    navigate(generatePath(completeRoute, { userId: userId?.toString() }))
  }, [])
  const handleProfile = useCallback(({ resourceIds }) => {
    navigate(profilingRoute, {
      state: { profileFieldIds: resourceIds },
    })
  }, [])
  const handleCreateEnrollment = useCallback(() => {
    navigate(generatePath(enrollRoute, { userId: userId?.toString() }))
  }, [])

  return (
    <DrawField
      onComplete={handleComplete}
      onCreateEnrollment={handleCreateEnrollment}
      onCancel={handleCancel}
      onProfile={handleProfile}
      userId={userId}
    />
  )
}
